const userStore = {
    namespaced: true,
    state: {
        selectedTreatment: null,
        selectedDate: null,
        selectedTime: null
    },
    mutations: {
        selectTreatment(state, treatment) {
            state.selectedTreatment = treatment;
            console.log('Store: a treatment has been selected', state);
        },
        selectDateAndTime(state, dateTime) {
            state.selectedDate = new Date(dateTime.date);
            state.selectedTime = dateTime.time;

            console.log('Store: selectDateAndTime:', dateTime);
        }
    }
};
export default userStore